<template lang="html">
    <div class="cell-container">
        <a :href="value" target="_blank" rel="noopener" class="cell-value" @click="btnClickedHandler()" :title="value">{{ value }}</a>
    </div>
</template>
<script>
export default {
    name: 'LinkCellRenderer',
    data() {
        return {

        }
    },
    methods: {
        btnClickedHandler() {
            if (!this.params.clicked) return;

            this.params.clicked(this.params.data);
        }
    },
    computed: {
        value() {
            return this.params.value ?? '-';
        }
    }
}
</script>
<style lang="css">
.cell-value {
    max-width: 80%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
</style>